<template>
  <v-toolbar-items class="b-menu-header-list">
    <!--  -->

    <template v-for="item in menuList">
      <v-btn
        :key="item.title"
        :to="item.disabled ? null : item.route"
        :href="item.href"
        :target="item.target"
        :disabled="item.disabled"
        text
      >
        {{ item.title }}
      </v-btn>
    </template>

    <!--  -->
  </v-toolbar-items>
</template>

<script>


export default {
  name: 'BMenuHeaderList',
  props: {
    menuList: {
      type: Array,
      required: true,
    },
  },
}
</script>
